import { FilterStatus } from "@/components/StatusTableTab";
import { createContext, Dispatch, SetStateAction, useContext } from "react";

export type FilterStatusContextType = {
  filterStatus: FilterStatus;
  setFilterStatus: Dispatch<SetStateAction<FilterStatus>>;

  setWhereQuery: object;

  setId: string | undefined;
  setSetId: Dispatch<SetStateAction<string | undefined>>;
  computeFilterStatusQueryContent: <T>(statusField: keyof T) => object;
};

export const AdditionalFiltersContext = createContext<
  FilterStatusContextType | undefined
>(undefined);

export function useAdditionalFilters() {
  const context = useContext(AdditionalFiltersContext);
  return context;
}

/**
 * To access the setId from outside the context
 */
export function useSetExternal() {
  const getSetId = (resourceType: string) => {
    const item = localStorage.getItem(`${resourceType}.setId`);
    if (item == undefined) return undefined;
    return JSON.parse(item);
  };

  const deleteSetId = (resourceType: string) => {
    localStorage.removeItem(`${resourceType}.setId`);
  };

  const setSetId = (resourceType: string, value: string) => {
    localStorage.setItem(`${resourceType}.setId`, JSON.stringify(value));
  };

  return { getSetId, deleteSetId, setSetId };
}
